import { db } from "../firebase-config";
import { getDoc, setDoc, doc, onSnapshot } from "firebase/firestore";

export const updateOrganizationTimeMethod = async (organization, timeMethod) => {
    const docRef = doc(db, "organizations", organization, "static_documents", "settings");
    try {
        await setDoc(docRef, {
            time_method: timeMethod
        }, { merge: true });

        return { success: true, error: null };
    } catch (error) {
        console.error("Error updating time method:", error);
        return { success: false, error: error.message || 'Failed to update time method' };
    }
};

export const getOrgSettings = async(organization) => {
    var docRef = doc(db, "organizations", organization, "static_documents", "settings");
    return await getDoc(docRef)
}

export const productCategorySnapshotListener = async (organization, onProductUpdate) => {
    const productDocRef = doc(db, "organizations", organization, "static_documents", "product_category");

    const unsubscribe = onSnapshot(productDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            const productCategories = docSnapshot.data().categories || []; // Access the 'categories' array in the document
            onProductUpdate(productCategories); // Call the update function with the categories array
        } else {
            console.warn("No categories found in document.");
            onProductUpdate([]); // Return an empty array if the document doesn't exist or has no categories
        }
    });

    return () => unsubscribe();
};